// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"4428dc95","339":"3448b23b","453":"a9b5dc73","867":"6f243ede"}[chunkId] + ".chunk.js";
};